import { render, staticRenderFns } from "./series_list.vue?vue&type=template&id=580b8379&scoped=true"
import script from "./series_list.vue?vue&type=script&lang=js"
export * from "./series_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b8379",
  null
  
)

export default component.exports